module.exports = __webpack_public_path__ + "img/t1.2d82f104.svg";